/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {

	/**
	 * @author Thomas Amsler
	 * @namespace Tc.Module.Scene7Stage
	 * @class Scene7Stage
	 * @extends Tc.Module
	 */

	Tc.Module.Scene7Stage = Tc.Module.extend({

		/**
		 * @method on
		 * @param {Function}
		 *            callback function
		 * @return void
		 */
		on : function(callback) {
			var mod = this, $ctx = mod.$ctx;

			// load and parse dataObject json
			mod.dataObject = $ctx.data('json');

			// set defaults
			mod.image = $ctx.data('desktop-image');
			if (SCS.utils.isMobilePage()) {
				mod.image = $ctx.data('mobile-image');
			}
			mod.s7Url = mod.image + '?$Original%20Size$';

			setTimeout(mod.loadDefaultImage.bind(mod), 3000);
			callback();
		},

		/**
		 * @method loadDefaultImage
		 * @return void
		 */
		loadDefaultImage : function() {
			var mod = this, $ctx = mod.$ctx;
			var img = $ctx.find('img')[0];
			if (img.naturalWidth == 1) {
				if (SCS.utils.isMobilePage()) {
					img.src = $ctx.data('mobile-src');
				} else {
					img.src = $ctx.data('desktop-src');
				}
			}
		},

		/**
		 * @method updateImageSrc
		 * @param {String}
		 *            zalCode to load
		 * @param {String}
		 *            condId to load
		 * @param {String}
		 *            segment to load
		 * @return void
		 */
		updateImageSrc : function(zalCode, condId, segment) {
			var mod = this;
			var img = mod.$ctx.find('img');
			var data = mod.getDataObject(zalCode, condId, segment);
			
			mod.s7Url = mod.image + '?$Original%20Size$&';
			mod.s7Url += $.param(data||{}).replace(/(^|&)/g, '$1$')
			img.attr('src', mod.s7Url);
		},

		/**
		 * @method updateLink
		 * @param {String}
		 *            zalCode to load
		 * @param {String}
		 *            condId to load
		 * @param {String}
		 *            segment to load
		 * @param {String}
		 *            linkProperty property name of the link
		 * @param {String}
		 *            addParameter query string with additional
		 *            parameter
		 * @return void
		 */
		updateLink : function(zalCode, condId, segment, linkProperty,
				addParameter) {
			var mod = this, $ctx = mod.$ctx;

			var data = mod.getDataObject(zalCode, condId, segment);
			if (data) {
				var link = data[linkProperty];
				if (link) {
					var href = unescape(link)
					if (href.indexOf('?') > -1) {
						href += '&'
					} else {
						href += '?'
					}
					href += addParameter;
					$ctx.attr('href', href);
				}
			}
		},

		/**
		 * @method getDataObject
		 * @param {String}
		 *            zalCode to load
		 * @param {String}
		 *            condId to load
		 * @param {String}
		 *            segment to load
		 * @return {Object} the data object with all defined PSD layers
		 */
		getDataObject : function(zalCode, condId, segment) {
			var mod = this;
			var zalObj = mod.dataObject[zalCode];
			if (!zalObj) {
				return;
			}

			var condIdObj = zalObj[condId];
			if (!condIdObj) {
				return;
			}

			var segmentObj = condIdObj[segment.toUpperCase()];
			if (!segmentObj) {
				return;
			}

			return segmentObj;
		}
	});
})(Tc.$);
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Scene7Stage.js
// module id = 179
// module chunks = 0